import renderer from '@servicenow/ui-renderer-default';

export const DEFAULT_RENDERER = {
	type: renderer,
	transformState: state => state,
	view: () => null
};
